import styled from 'vue-styled-components';

const menuLinkProps = {
	backgroundColor: {
		type: String,
		default: '#ffffff',
	},
};

const menuLink = styled('a', menuLinkProps)`
	display: block; 
	width: 100%; 
	height: 100%;
	background-color: ${props => props.backgroundColor};
	font-family: 'Bitter', serif;
	font-size: 1.1rem;
	line-height: 1.2;
	text-decoration: none;
	color: ${props => props.theme.darkGrey};
	transition: .5s ease all;
`;

export { menuLink as default };
